import Login from "../views/Login.svelte";
import { mainRoutres } from "./mainRoutres";
import NotFound from "../views/NotFound.svelte";

export default {
    "/": Login,
    ...mainRoutres,
    "*": NotFound,
};
